import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import ScrollToTop from "../../components/ScrollTop";
import Test from "../../components/LevelTest/Test";
import DownloadApp from "../home/DownloadApp";

const LevelTest = () => {
  return (
    <body className="courses-grid-page">
      <Header parentMenu="course" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle="Level Test" />
          <Test />
          {/* download-app-start */}
          <DownloadApp />
          {/* download-app-end */}
          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <Footer />
    </body>
  );
};

export default LevelTest;
